var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSentimentMinus(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18251_303982)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.5706 14.9674H9.28581C8.94231 14.9674 8.62407 14.7855 8.45232 14.4875C8.28057 14.1894 8.28057 13.8207 8.45232 13.5226C8.62407 13.2246 8.94231 13.0427 9.28581 13.0427H19.5706C19.9141 13.0427 20.2323 13.2246 20.404 13.5226C20.5758 13.8207 20.5758 14.1894 20.404 14.4875C20.2323 14.7804 19.9141 14.9674 19.5706 14.9674ZM14.4282 0.5C6.97224 0.5 0.925659 6.54658 0.925659 14.0025C0.925659 21.4585 6.97224 27.505 14.4282 27.505C21.8841 27.505 27.9307 21.4585 27.9307 14.0025C27.9307 6.54658 21.8841 0.5 14.4282 0.5Z",
    fill: "#2870ED"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18251_303982"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 27,
    fill: "white",
    transform: "translate(0.925659 0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSentimentMinus);
export default __webpack_public_path__ + "static/media/sentiment_minus.9743a6e6f19757d5fbc7d8d88ba7046e.svg";
export { ForwardRef as ReactComponent };